/* FyreFit cart: drawer and cart page.
   Adds, quantity changes, removals and notes go through Shopify's AJAX cart API with the Section Rendering API,
   so the drawer and the cart page are always re-rendered by the theme's own Liquid. */
(function () {
  if (window.FFCart) return;
  var config = window.FFCartConfig || {};
  var root = (config.root || '/').replace(/\/?$/, '/');
  var routes = {
    add: config.addUrl || root + 'cart/add',
    change: config.changeUrl || root + 'cart/change',
    update: config.updateUrl || root + 'cart/update',
    cart: config.cartUrl || root + 'cart'
  };
  var busy = false;
  var lastFocus = null;

  // A page can swap the network layer (the design prototype does). The default talks to Shopify.
  var transport = window.FFCartTransport || {
    post: function (url, body) {
      var isForm = typeof FormData !== 'undefined' && body instanceof FormData;
      return fetch(url + '.js', {
        method: 'POST',
        headers: isForm ? { Accept: 'application/json' } : { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: isForm ? body : JSON.stringify(body)
      }).then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok || data.status) {
            var error = new Error(data.description || data.message || 'Cart request failed');
            error.data = data;
            throw error;
          }
          return data;
        });
      });
    }
  };

  function drawer() { return document.querySelector('[data-ff-cart-drawer]'); }
  function sectionEls() { return Array.prototype.slice.call(document.querySelectorAll('[data-ff-cart-section]')); }
  function sectionIds() { return sectionEls().map(function (el) { return el.getAttribute('data-section-id'); }).filter(Boolean); }

  function announce(text) {
    var live = document.querySelector('[data-ff-cart-live]');
    if (live) { live.textContent = ''; setTimeout(function () { live.textContent = text; }, 30); }
  }

  function addBusinessDays(date, days) {
    var d = new Date(date.getTime());
    while (days > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) days -= 1;
    }
    return d;
  }
  function fillDispatch(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-ff-dispatch]'), function (el) {
      var days = Number(el.getAttribute('data-days')) || 0;
      var label = addBusinessDays(new Date(), days).toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' });
      var template = el.getAttribute('data-template') || '';
      if (template.indexOf('[date]') !== -1) el.textContent = template.replace('[date]', label);
    });
  }

  function count() {
    var inner = document.querySelector('[data-ff-cart-inner]');
    return inner ? Number(inner.getAttribute('data-count')) || 0 : 0;
  }
  function publishCount() {
    var n = count();
    Array.prototype.forEach.call(document.querySelectorAll('[data-ff-cart-count]'), function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
    document.dispatchEvent(new CustomEvent('ff:cart:change', { detail: { item_count: n } }));
  }

  // Replace each section's cart body with the freshly rendered one, keeping focus where it was.
  function render(sections) {
    if (!sections) return;
    var active = document.activeElement;
    var focusKey = null;
    if (active && active.closest) {
      var line = active.closest('[data-ff-line]');
      if (line) focusKey = { line: line.getAttribute('data-ff-line'), qty: active.getAttribute('data-ff-qty'), input: active.hasAttribute('data-ff-qty-input') };
    }
    sectionEls().forEach(function (el) {
      var html = sections[el.getAttribute('data-section-id')];
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-ff-cart-inner]');
      var current = el.querySelector('[data-ff-cart-inner]');
      if (fresh && current) current.replaceWith(document.importNode(fresh, true));
      fillDispatch(el);
    });
    var target = focusKey ? document.querySelector('[data-ff-line="' + focusKey.line + '"] ' + (focusKey.input ? '[data-ff-qty-input]' : '[data-ff-qty="' + focusKey.qty + '"]')) : null;
    if (target) target.focus();
    else if (active && !document.contains(active)) {
      // The focused control was replaced (a removed line, an added suggestion): keep focus inside the cart.
      var d = drawer();
      var panel = d && !d.hidden ? d.querySelector('.ff-cdrawer__panel') : null;
      if (panel) panel.focus();
    }
    publishCount();
  }

  function setBusy(on) {
    busy = on;
    sectionEls().forEach(function (el) {
      var inner = el.querySelector('[data-ff-cart-inner]');
      if (inner) inner.setAttribute('aria-busy', on ? 'true' : 'false');
    });
  }

  function open() {
    var d = drawer();
    if (!d) { window.location.href = routes.cart; return; }
    if (!d.hidden) return;
    lastFocus = document.activeElement;
    d.hidden = false;
    document.documentElement.classList.add('ff-cart-open');
    requestAnimationFrame(function () {
      d.classList.add('is-open');
      var panel = d.querySelector('.ff-cdrawer__panel');
      if (panel) panel.focus();
    });
  }
  function close() {
    var d = drawer();
    if (!d || d.hidden) return;
    d.classList.remove('is-open');
    document.documentElement.classList.remove('ff-cart-open');
    var done = function () { d.hidden = true; };
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) done(); else setTimeout(done, 220);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function errorFor(form, message) {
    var box = form && form.closest('[id^="ff-pdp-"]');
    var target = box ? box.querySelector('[data-ff-add-err]') : null;
    if (target) { target.textContent = message; target.hidden = false; }
    else announce(message);
  }

  // items: [{ id, quantity, properties }] or a FormData from a product form.
  function add(items, sourceForm) {
    if (busy) return Promise.resolve();
    var body;
    if (typeof FormData !== 'undefined' && items instanceof FormData) {
      body = items;
      body.append('sections', sectionIds().join(','));
      body.append('sections_url', window.location.pathname);
    } else {
      body = { items: items, sections: sectionIds().join(','), sections_url: window.location.pathname };
    }
    setBusy(true);
    return transport.post(routes.add, body).then(function (data) {
      render(data.sections);
      open();
      announce('Added to your cart.');
      return data;
    }).catch(function (error) {
      errorFor(sourceForm, (error.data && error.data.description) || 'Could not add this to your cart. Try again.');
      throw error;
    }).finally(function () { setBusy(false); });
  }

  function change(key, quantity) {
    if (busy) return Promise.resolve();
    setBusy(true);
    return transport.post(routes.change, { id: key, quantity: quantity, sections: sectionIds().join(','), sections_url: window.location.pathname }).then(function (data) {
      render(data.sections);
      announce(quantity === 0 ? 'Removed from your cart.' : 'Cart updated.');
      return data;
    }).catch(function (error) {
      var line = document.querySelector('[data-ff-line="' + key + '"] [data-ff-line-err]');
      var message = (error.data && error.data.description) || 'Could not update the cart. Try again.';
      if (line) line.textContent = message; else announce(message);
    }).finally(function () { setBusy(false); });
  }

  function updateNote(note) {
    return transport.post(routes.update, { note: note }).catch(function () {});
  }

  // Product forms anywhere in FyreFit sections add through the drawer.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.closest('.ff')) return;
    var action = form.getAttribute('action') || '';
    var isAdd = action.indexOf('/cart/add') !== -1 || form.getAttribute('data-form-type') === 'product';
    if (!isAdd || !drawer()) return;
    event.preventDefault();
    var err = form.closest('[id^="ff-pdp-"]');
    if (err) { var e = err.querySelector('[data-ff-add-err]'); if (e) e.hidden = true; }
    var submitter = event.submitter || form.querySelector('[type="submit"]');
    if (submitter) submitter.setAttribute('aria-busy', 'true');
    add(new FormData(form), form).catch(function () {}).finally(function () { if (submitter) submitter.removeAttribute('aria-busy'); });
  });

  document.addEventListener('click', function (event) {
    var t = event.target;
    if (t.closest('[data-ff-cart-close]')) { event.preventDefault(); close(); return; }
    if (t.closest('[data-ff-cart-open]')) { event.preventDefault(); open(); return; }
    var qty = t.closest('[data-ff-qty]');
    if (qty) {
      var line = qty.closest('[data-ff-line]');
      var next = Math.max(0, (Number(line.getAttribute('data-qty')) || 0) + Number(qty.getAttribute('data-ff-qty')));
      change(line.getAttribute('data-ff-line'), next);
      return;
    }
    var rm = t.closest('[data-ff-remove]');
    if (rm) { event.preventDefault(); change(rm.closest('[data-ff-line]').getAttribute('data-ff-line'), 0); return; }
    var d = drawer();
    var link = t.closest('a[href]');
    if (link && d && d.getAttribute('data-intercept') === 'true' && !link.closest('[data-ff-cart-inner]')) {
      var href = link.getAttribute('href').split('?')[0].replace(/\/$/, '');
      if (href === routes.cart.replace(/\/$/, '')) { event.preventDefault(); open(); }
    }
  });

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-ff-qty-input]');
    if (input) {
      var line = input.closest('[data-ff-line]');
      var value = Math.max(0, parseInt(input.value, 10) || 0);
      if (value !== Number(line.getAttribute('data-qty'))) change(line.getAttribute('data-ff-line'), value);
      return;
    }
    var note = event.target.closest('[data-ff-note]');
    if (note) updateNote(note.value);
  });

  document.addEventListener('keydown', function (event) {
    var d = drawer();
    if (!d || d.hidden) return;
    if (event.key === 'Escape') { close(); return; }
    if (event.key !== 'Tab') return;
    var panel = d.querySelector('.ff-cdrawer__panel');
    var items = Array.prototype.slice.call(panel.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea, summary')).filter(function (el) { return el.offsetParent !== null; });
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (event.shiftKey && (document.activeElement === first || document.activeElement === panel)) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });

  window.FFCart = { open: open, close: close, add: add, change: change, render: render, refreshCount: publishCount };
  fillDispatch(document);
  publishCount();
})();
